import React from "react";
import { Link } from "react-router-dom";
import InnerLayout from "../InnerLayout";
import { QuickFactsCard } from "./CampusLifePageParts";
import { hostelRules } from "./hostelRulesData";

const hostel = {
  name: "Boys Hostel",
  description:
    "KLS VDIT provides comfortable and well-equipped accommodation for boys, ensuring a conducive environment for academic focus, discipline, peer learning, and personal growth.",

  dashboard: [
    ["Total Rooms", "82"],
    ["Capacity", "218"],
    ["Opening Time", "6:00 AM"],
    ["Closing Time", "9:00 PM"],
  ],

  occupancy: [
    ["Ground floor (Attached bathrooms)", "28", "56"],
    ["First floor (Common bathrooms)", "26", "78"],
    ["Second floor (Common bathrooms)", "28", "84"],
  ],

  facilities: [
    "Furnished rooms and clean bathrooms",
    "Mess with quality food",
    "Water purifier for drinking water",
    "Hot water facility on every floor",
    "24x7 Wi-Fi internet facility",
    "Pure drinking water through RO+UV filtering unit",
    "Electricity backup facility",
    "Uninterrupted power supply with generators",
  ],

  hostelTeam: {
    warden: "Mr. Praveen Tavakari - 9164345208",
    staffInCharge: [
      "Prof. Deepak Lokare - 9482024433",
      "Prof. Prakash Chavan",
    ],
  },

  overview:
    "The Boys Hostel at KLS VDIT is designed to provide a secure, hygienic, and student-friendly living environment with essential amenities that support academic excellence and overall well-being.",
};

const quickFacts = [
  ["Category", "Campus Life"],
  ["Facility", hostel.name],
  ["Total Rooms", "82"],
  ["Capacity", "218"],
  ["Timings", "6:00 AM to 9:00 PM"],
  ["Warden", hostel.hostelTeam.warden],
];

const BoysHostel = () => {
  return (
    <InnerLayout
      title={hostel.name}
      image="/Campus/boyshostelhero.png"
      breadcrumbs={[
        { label: "Campus Life", to: "/campus" },
        { label: "Hostels", to: "/campus-life/hostels" },
        { label: hostel.name },
      ]}
      sidebar={null}
    >
      <div className="grid gap-8 lg:grid-cols-3 lg:gap-10 items-start">
        <section className="min-w-0 lg:col-span-2">
          <Link
            to="/campus-life/hostels"
            className="inline-flex items-center gap-2 text-sm text-brand font-semibold hover:underline mb-6"
          >
            Back to Hostels
          </Link>

        <h2
          className="text-2xl sm:text-3xl md:text-4xl text-brand font-semibold mb-4 sm:mb-5"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          {hostel.name}
        </h2>
        <p className="text-[#2a2a2a]/85 leading-relaxed text-[15px] sm:text-[16px] max-w-4xl">
          {hostel.description}
        </p>
        <p className="text-[#2a2a2a]/85 leading-relaxed text-[15px] sm:text-[16px] max-w-4xl mt-4">
          {hostel.overview}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 mt-7 sm:mt-8">
          {hostel.dashboard.map(([label, value]) => (
            <div key={label} className="bg-brand border border-brand p-4 sm:p-5 min-h-[88px] flex flex-col justify-center">
              <p
                className="text-2xl text-white font-semibold leading-tight"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                {value}
              </p>
              <p className="text-[11px] sm:text-xs uppercase tracking-[0.12em] sm:tracking-[0.16em] text-white font-sans-ui font-semibold mt-3 leading-snug">
                {label}
              </p>
            </div>
          ))}
        </div>

        <div className="grid gap-5 lg:grid-cols-2 lg:gap-8 mt-8 sm:mt-10">
          <div className="bg-white border border-brand/15 p-4 sm:p-5">
            <h3 className="text-lg sm:text-xl text-brand font-semibold">Facilities</h3>
            <ul className="list-disc pl-5 mt-3 space-y-2 text-sm sm:text-base text-[#2a2a2a]/85">
              {hostel.facilities.map((facility) => (
                <li key={facility}>{facility}</li>
              ))}
            </ul>
          </div>

          <div className="bg-white border border-brand/15 p-4 sm:p-5">
            <h3 className="text-lg sm:text-xl text-brand font-semibold">Hostel Team</h3>
            <div className="mt-3 space-y-4 text-sm sm:text-base text-[#2a2a2a]/85">
            <div>
                <p className="text-xs sm:text-sm uppercase tracking-[0.16em] sm:tracking-widest text-brand font-semibold">
                  Warden
                </p>
                <p className="mt-2">{hostel.hostelTeam.warden}</p>
              </div>
              <div>
                <p className="text-xs sm:text-sm uppercase tracking-[0.16em] sm:tracking-widest text-brand font-semibold">
                  Staff In-charge
                </p>
                <ul className="list-disc pl-5 mt-2 space-y-1">
                  {hostel.hostelTeam.staffInCharge.map((member) => (
                    <li key={member}>{member}</li>
                  ))}
                </ul>
              </div>
              
            </div>
          </div>
        </div>

        <div className="bg-white border border-brand/15 p-4 sm:p-5 mt-6 sm:mt-8">
          <h3 className="text-lg sm:text-xl text-brand font-semibold">Occupancy Details</h3>
          <div className="-mx-4 sm:mx-0 overflow-x-auto mt-4">
            <table className="min-w-[560px] sm:min-w-full text-sm text-left">
              <thead className="bg-brand text-surface">
                <tr>
                  <th className="px-4 py-3 font-semibold">Floor</th>
                  <th className="px-4 py-3 font-semibold">Rooms</th>
                  <th className="px-4 py-3 font-semibold">Maximum Occupancy</th>
                </tr>
              </thead>
              <tbody>
                {hostel.occupancy.map(([floor, rooms, occupancy]) => (
                  <tr key={floor} className="border-t border-brand/10">
                    <td className="px-4 py-3 text-[#2a2a2a]">{floor}</td>
                    <td className="px-4 py-3 text-[#2a2a2a]">{rooms}</td>
                    <td className="px-4 py-3 text-[#2a2a2a]">{occupancy}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="bg-white border border-brand/15 p-4 sm:p-5 mt-6 sm:mt-8">
          <h3 className="text-lg sm:text-xl text-brand font-semibold">Rules and Regulations</h3>
          <ol className="list-decimal pl-5 mt-3 space-y-2 text-sm sm:text-base text-[#2a2a2a]/85">
            {hostelRules.map((rule) => (
              <li key={rule}>{rule}</li>
            ))}
          </ol>
        </div>
        </section>

        <aside className="bg-white border border-brand/15 p-4 sm:p-5 lg:sticky lg:top-36">
          <QuickFactsCard facts={quickFacts} />
        </aside>
      </div>
    </InnerLayout>
  );
};

export default BoysHostel;
